import React from "react";
import { Quote } from "../js/components/Article/Quote/Quote";
import { Steps } from "../js/components/Article/Steps/Steps";
import { Hero } from "../js/components/Article/Hero/Hero";
import { TwoUp } from "../js/components/Article/TwoUp/TwoUp";
import { FullWidthHero } from "../js/components/Article/FullWidthHero/FullWidthHero";
import { SmallTwoUp } from "../js/components/Article/SmallTwoUp/SmallTwoUp";
import { Video } from "../js/components/Article/Video/Video";
import { Body } from "../js/components/Article/Body/Body";
import { ImageShop } from "../js/components/Article/ImageShop/ImageShop";
import { FeaturedProducts } from "../js/components/Article/FeaturedProducts/FeaturedProducts";
import { TextProduct } from "../js/components/Article/TextProduct/TextProduct";
import { CTAButton } from "../js/components/Article/CTAButton/CTAButton";

const SliceZone = ({ sliceZone }) => (
	<div className="article-container">
		{sliceZone.map((slice, index) => {
			switch (slice.slice_type) {
				case "quote":
					return <Quote data={slice} key={`slice-${index}`} />;
				case "steps":
					return <Steps data={slice} key={`slice-${index}`} />;
				case "hero":
					return <Hero data={slice} key={`slice-${index}`} />;
				case "bigtwoup":
					return <TwoUp data={slice} key={`slice-${index}`} />;
				case "fullwidthhero":
					return <FullWidthHero data={slice} key={`slice-${index}`} />;
				case "small_two_up":
					return <SmallTwoUp data={slice} key={`slice-${index}`} />;
				case "text_and_video":
					return <Video data={slice} key={`slice-${index}`} />;
				case "text_and_product":
					return <TextProduct data={slice} key={`slice-${index}`} />;
				case "featured_products":
					return <FeaturedProducts data={slice} key={`slice-${index}`} />;
				case "body":
					return <Body data={slice} key={`slice-${index}`} />;
				case "image_and_shop_link":
					return <ImageShop data={slice} key={`slice-${index}`} />;
				case "cta_button":
					return <CTAButton data={slice} key={`slice-${index}`} />;
				default:
					return <p> i dont know what i am</p>;
			}
		})}
	</div>
);

export default SliceZone;
